import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';
import Gallery, { GalleryImage } from '../components/Gallery';
import Breadcrumb from '../components/Breadcrumb';

const People = () => {
  const { t } = useTranslation('navigation');
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || 'en';

  const getLocalizedPath = (path: string) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLanguage}${cleanPath}`;
  };
  const panoImages: GalleryImage[] = [
    { src: '/images/people/person0.jpg', alt: 'Film photography panoramic portrait - Professional analog photographer Marbella Costa del Sol' },
  ];

  const peopleImages: GalleryImage[] = [
    { src: '/images/people/person1.jpg', alt: 'Fine art film portrait photography - Black and white analog portrait Marbella' },
    { src: '/images/people/person2.jpg', alt: 'Professional film portrait session - Analog photography Costa del Sol' },
    { src: '/images/people/person3.jpg', alt: 'Artistic film portrait - Fine art photography Estepona Marbella' },
    { src: '/images/people/person4.jpg', alt: 'Film photography portrait session - Professional analog photographer Spain' },
    { src: '/images/people/person5.jpg', alt: 'Black and white film portrait - Timeless analog photography Costa del Sol' },
    { src: '/images/people/person6.jpg', alt: 'Fine art portrait on film - Professional film photographer Marbella Malaga' },
  ];

  return (
    <Box maxW="1200px" mx="auto" p={4} paddingTop={{ base: "80px", md: "20px" }}>
      {/* Breadcrumb */}
      <Box mb={6}>
        <Breadcrumb 
          items={[
            { label: t('breadcrumbs.work'), href: getLocalizedPath('/') },
            { label: t('breadcrumbs.people') }
          ]} 
        />
      </Box>

      <Text fontSize="3xl" fontWeight="bold" mb={4} mt={4} textAlign="center">
        {t('breadcrumbs.people')}
      </Text>
      <Gallery
        images={panoImages}
        columns={{ base: 1, md: 1, lg: 1 }}
        spacing={4}
      />
      
      <Box mt={8}>
        <Gallery
          images={peopleImages}
          columns={{ base: 1, md: 2, lg: 3 }}
          spacing={4}
        />
      </Box>
    </Box>
  );
};

export default People;